module.exports = __webpack_public_path__ + "fc173a31456503112c93fcdfed8a9be5.svg";